import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { AutoStories } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    minHeight: '400px',
  },
  paper: {
    padding: '40px',
    maxWidth: '600px',
    textAlign: 'center',
    borderRadius: '12px',
  },
  icon: {
    fontSize: '80px',
    color: '#9e9e9e',
    marginBottom: '24px',
  },
  title: {
    marginBottom: '16px',
    fontWeight: 600,
    color: '#424242',
  },
  message: {
    color: '#757575',
    lineHeight: 1.6,
  },
}));

function EmptyStudyPlanMessage() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper} elevation={2}>
        <AutoStories className={classes.icon} />
        <Typography variant="h5" className={classes.title}>
          Aún no se tiene un plan de estudios
        </Typography>
        <Typography variant="body1" className={classes.message}>
          El plan de estudios se encuentra en proceso de creación.
          Serás notificado una vez que esté disponible para visualizar los programas y horarios.
        </Typography>
      </Paper>
    </Box>
  );
}

export default EmptyStudyPlanMessage;
